import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { MaterialList, MaterialListDefaultValues, MaterialQueryFilters, MaterialQueryFiltersDefaultValues } from 'src/app/components/materials/material-list';
import { NoResultsComponent } from 'src/app/components/no-results/no-results.component';
import { AuthService } from 'src/app/services/auth.service';
import { CourseService } from 'src/app/services/course.service';
import { MaterialsService } from 'src/app/services/materials.service';

@Component({
    selector: 'app-material-list',
    templateUrl: './material-list.component.html',
    styleUrls: ['./material-list.component.scss'],
    standalone: false
})
export class MaterialListComponent implements OnInit {

  materiallist: MaterialList[] = [];
  totalRecords: number = 0;
  columnsToDisplay = [
    'name','id','type','language','course', 'status',
  ];
  pageEvent!: PageEvent;
  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild('noResults') noResults!: NoResultsComponent;
  @ViewChild('submitButton') submitButton!: ElementRef;
  information: string = '';
  queryFilter: MaterialQueryFilters = MaterialQueryFiltersDefaultValues();
  materialTypes: any[] = [];
  materialLanguage: any[] = [];
  materialStatus: any[] = [];
  courseList: any[] = [];
  pageName = CheckPageAccess.MATERIALS;
  showaddbutton = this.authservice.getAccessControl().addMaterials;

  constructor(public materialservice: MaterialsService,
    public courseservice: CourseService,
    private authservice: AuthService)
  {}

  async ngOnInit(): Promise<void> {
    this.information="<h4>Status Definitions</h4>"+
    "<br/><span>Draft:</span> Material is in progress and not yet finalized. It can be edited and is not visible to participants. It can be associated with a draft course.<br/><br/>"+
    "<span>Published:</span> Material is finalized and available for use in published courses. It can be edited if it is associated with draft courses or published courses with zero enrolments.<br/><br/>"+
    "<span>Retired:</span> Material is no longer actively used for new courses but remains accessible to users who started using it while it was in the published status. It cannot be edited.";

    this.materialTypes = await this.materialservice.getMaterialTypes();

    this.materialservice.getMaterialLanguages().subscribe({
      next: (data) => {
        this.materialLanguage = data;
      }
    });

    await this.materialservice.getMaterialStatus("ALL").subscribe({
      next:(resp) => {
        this.materialStatus = resp;
      }
    });

    await this.courseservice.getCoursesForMaterials().subscribe({
      next:(resp) => {
        this.courseList = resp;
      }
    });

    this.queryFilter.Tag = 0;
    this.searchWithFilters()
  }

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.queryFilter.PageNumber = e.pageIndex
    this.queryFilter.PageSize = e.pageSize
    this.searchWithFilters();
  }

  private searchWithFilters() {
    this.materialservice.getAllMaterials(this.queryFilter).subscribe({
      next: (data) => {
        let headers = data.headers.get('x-pagination');
        if (headers) {
          let parsedHeaders = JSON.parse(headers);
          this.totalRecords = parsedHeaders.TotalCount;
          this.noResults.setTotal(this.totalRecords);
        }
        this.materiallist = data.body ? data.body : [];
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => { }
    });
  }

  @HostListener('document:keypress', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent): void {
	  if (event.key === 'Enter') {
		this.submitButton.nativeElement.click();
		event.preventDefault();
	  }
	}

  resetFilters() {
  this.queryFilter = MaterialQueryFiltersDefaultValues();
  this.search();
    }

  search() {
    this.searchWithFilters();
    }
}
